import { isValid, parse } from "date-fns";
import {
  IParseBirthday,
  isValidBirthday,
  parseBirthday
} from "./helpers/birtday.helpers";
import { IParseID, isValidID, parseID } from "./helpers/id.helpers";
import { CustomerInput } from "../../generated/graphql";

export interface IValidateError {
  error: string;
}

export enum ID_TYPES {
  RC = "rc",
  DATE = "date"
}

export function isMinor(age: number) {
  return age < 18;
}

export const isForeign = (investor: CustomerInput) => {
  if (!isChild(investor)) {
    return (
      (investor.document.citizen !== "" &&
        investor.document.citizen !== "cz") ||
      decideRCorBirthday(investor.id) === ID_TYPES.DATE
    );
  }

  return (
    (investor.acting.document.citizen !== "" &&
      investor.acting.document.citizen !== "cz") ||
    decideRCorBirthday(investor.acting.id) === ID_TYPES.DATE
  );
};

export const isNonTaxDomicile = (investor: CustomerInput) => {
  if (isChild(investor)) {
    return (
      investor.acting.document.taxResident !== "" &&
      investor.acting.document.taxResident !== "cz"
    );
  }

  return (
    investor.document.taxResident !== "" &&
    investor.document.taxResident !== "cz"
  );
};

export const isChild = (investor: CustomerInput) => {
  if (!investor) {
    return false;
  }
  const parsed = parseRCorBirthday(investor.id);
  return parsed && parsed.age < 18;
};

export const isDip = (code: string) => {
  return code === "7" || code === "8";
};

export const decideRCorBirthday = (value: string) => {
  if (isValid(parse(value, "dd.MM.yyyy", new Date()))) {
    return ID_TYPES.DATE;
  } else {
    return ID_TYPES.RC;
  }
};

export const parseRCorBirthday = (
  value: string
): IParseID | IParseBirthday | false => {
  const typeofValue = decideRCorBirthday(value);
  if (typeofValue === ID_TYPES.DATE) {
    const date = parse(value, "dd.MM.yyyy", new Date());
    return parseBirthday(date);
  }

  if (typeofValue === ID_TYPES.RC) {
    return parseID(value);
  }
};

export const validateRCorBirthday = (
  value: string
): boolean | IValidateError => {
  const typeofValue = decideRCorBirthday(value);

  if (typeofValue === ID_TYPES.DATE) {
    return isValidBirthday(value);
  }

  if (typeofValue === ID_TYPES.RC) {
    return isValidID(value);
  }
};

export const isAccountNumberValid = (value: string): boolean => {
  const prefixWeights = [10, 5, 8, 4, 2, 1];

  const baseWeights = [6, 3, 7, 9, 10, 5, 8, 4, 2, 1];

  const matches = value.match(/^(([0-9]{0,6})-)?([0-9]{2,10})$/);

  if (!matches) {
    return false;
  }

  if (matches[2]) {
    const prefix = matches[2].padStart(6, "0");
    let sum = 0;
    for (let i = 0; i < 6; i++) {
      sum += parseInt(prefix[i]) * prefixWeights[i];
    }

    if (sum % 11 !== 0) {
      return false;
    }
  }

  const base = matches[3].padStart(10, "0");

  let sum2 = 0;
  for (let i = 0; i < 10; i++) {
    sum2 += parseInt(base[i]) * baseWeights[i];
  }

  if (sum2 % 11 != 0) {
    return false;
  }

  return true;
};
